var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFirstPageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7803 7.28033C16.0732 6.98744 16.0732 6.51256 15.7803 6.21967C15.4874 5.92678 15.0126 5.92678 14.7197 6.21967L9.71967 11.2197C9.42678 11.5126 9.42678 11.9874 9.71967 12.2803L14.7197 17.2803C15.0126 17.5732 15.4874 17.5732 15.7803 17.2803C16.0732 16.9874 16.0732 16.5126 15.7803 16.2197L11.3107 11.75L15.7803 7.28033Z",
    fill: "#424242"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 6.75L8 16.75C8 17.1642 8.33579 17.5 8.75 17.5C9.16421 17.5 9.5 17.1642 9.5 16.75L9.5 6.75C9.5 6.33579 9.16421 6 8.75 6C8.33579 6 8 6.33579 8 6.75Z",
    fill: "#424242"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirstPageIcon);
export default __webpack_public_path__ + "static/media/FirstPageIcon.437cc5cafbfe326e18bf60754f9752ba.svg";
export { ForwardRef as ReactComponent };